import Marquee from "react-fast-marquee";

const ITEMS = [
  "NO CORPORATE NONSENSE",
  "BRISTOL BUILT",
  "MASTER-LEVEL PRECISION",
  "FIRST-TIME FIXES",
  "30+ YEARS EXPERIENCE",
  "ZERO WAFFLE",
];

export const EditorialMarquee = () => {
  return (
    <section data-testid="marquee" className="relative border-y border-white/10 bg-black py-8">
      <Marquee speed={40} gradient gradientColor="#000000" gradientWidth={120} autoFill>
        {ITEMS.map((t, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display text-3xl font-700 uppercase tracking-tight chrome-text-soft md:text-5xl">
              {t}
            </span>
            <span className="mx-10 text-2xl text-[#ffb000] md:mx-16 md:text-4xl">✦</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
};
